import React from 'react';
import styled from 'styled-components';
import './App.css';
import Main from './components/Main';

const MainWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;

  font-family: 'Montserrat', Verdana, sans-serif;
  font-size: 70%;

  @media (min-width: 600px) {
    font-size: 85%;
  }

  @media (min-width: 1025px) {
    font-size: 100%;
  }
`;

const Footer = styled.div`
  color: #fff;
  background: #333;
  margin-top: auto;
  padding: 10px 0px;
  width: 100vw;
`;

const Header = styled.div`
  background: #fff;
  width: 100vw;
  padding: 10px 0px;
  box-sizing: border-box;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  text-align: left;
  position: sticky;
  top:0;
  z-index: 100;
`;

const TitleLink = styled.div`
  display: inline;
  margin-right: 50px;
  margin-left: 15px;
  font-family: 'Rouge Script', cursive;
  font-size: 2em;
  color: #D89400;

  @media (min-width: 600px) {
    margin-left: 30px;
  }  
`;

const DesktopLinks = styled.div`
  display: none;

  @media (min-width: 700px) {
    display: inline;
  }
`;

const Link = styled.div`
  display: inline;
  margin-right: 30px;

  a {
    color: #000;
    text-decoration: none;
  }

  a:hover {
    color: #D89400;
  }
`;

const Unlinked = styled.div`
  display: inline;
  color: #999;
  margin-right: 30px;
`;


function App() {
  return (
    <div className="App">
      <MainWrapper>
        <Header>
          <TitleLink>
            Shirley and Wei
          </TitleLink>
          <DesktopLinks>
            <Unlinked>
              Gallery
            </Unlinked>
            <Link>
              <a href='#location'>Location</a>
            </Link>
            <Link>
              <a href='#events'>Events</a>
            </Link>
            <Link>
              <a href='#registry'>Registry</a>
            </Link>
            <Link>
              <a href='#faq'>FAQ</a>
            </Link>
            <Link>
              <a href='https://shirleyandweiwedding.rsvpify.com/'>RSVP</a>
            </Link>
          </DesktopLinks>
        </Header>
        <Main />
        <Footer>
          &copy; 2021 Wei Kong.
        </Footer>
      </MainWrapper>
    </div>
  );
}

export default App;
